module.exports = __webpack_public_path__ + "static/media/mh-2.722540c6.jpg";